import type { ThemeSetting } from '@/theme/themeTypes';

export interface RawKuduProfile {
  first_name?: string | null;
  firstName?: string | null;
  institute?: string | null;
  institute_official_id?: string | null;
  instituteOfficialId?: string | null;
  is_google?: boolean | null;
  is_assistant?: boolean | null;
  is_instructor?: boolean | null;
  isAssistant?: boolean | null;
  isGoogle?: boolean | null;
  isInstructor?: boolean | null;
  last_name?: string | null;
  lastName?: string | null;
  preferred_email?: string | null;
  preferred_username?: string | null;
  preferredEmail?: string | null;
  preferredUsername?: string | null;
}

export interface RawDisplayPreferences {
  theme?: string | null;
}

export interface RawUserSettings {
  display?: RawDisplayPreferences | null;
  displayTheme?: string | null;
}

export interface RawKuduUser {
  course_ids?: string[] | null;
  courseIds?: string[] | null;
  dismissed_tours?: string[] | null;
  dismissedTours?: string[] | null;
  id?: string | null;
  profile?: RawKuduProfile | null;
  settings?: RawUserSettings | null;
  uid?: string | null;
}

export interface RawGetUserResponse {
  user?: RawKuduUser | null;
}

export interface RawUpdateUserResponse {
  user?: RawKuduUser | null;
}

export interface ProfileData {
  courseIds: string[];
  dismissedTours: string[];
  firstName: string;
  instituteOfficialId: string;
  isAssistant?: boolean;
  isInstructor: boolean;
  lastName: string;
  loginEmail: string | null;
  preferredEmail: string;
  rawProfile: Record<string, unknown> | null;
  rawSettings: Record<string, unknown> | null;
  settings: UserSettingsData;
  userId: string;
}

export interface UserSettingsData {
  displayTheme: ThemeSetting | null;
}

export interface ProfileDraft {
  firstName: string;
  instituteOfficialId: string;
  lastName: string;
  preferredEmail: string;
}

export interface ProfileValidationErrors {
  firstName?: string;
  lastName?: string;
  preferredEmail?: string;
}

export interface UpdateProfileParams {
  profile: {
    firstName: string;
    instituteOfficialId: string;
    isInstructor: boolean;
    lastName: string;
    preferredEmail: string;
  };
  userId: string;
}

export interface UpdateDisplayThemeParams {
  theme: ThemeSetting;
  userId: string;
}

export interface UpdateDismissedTourParams {
  tourId: string;
  userId: string;
}

export interface ProfileService {
  getProfile(params: { userId: string }): Promise<ProfileData>;
  updateDismissedTour(
    params: UpdateDismissedTourParams,
  ): Promise<ProfileData | null>;
  updateDisplayTheme(
    params: UpdateDisplayThemeParams,
  ): Promise<ProfileData | null>;
  updateProfile(params: UpdateProfileParams): Promise<ProfileData | null>;
}

export function profileQueryKey(userId: string | null | undefined) {
  return ['user-profile', userId] as const;
}
